import type { PackageState } from "#graphql/supergraphTypes";

/** One word per state, shared by the header tag and the summary footer. They
 *  sit in the same slideout, so a second wording for one state would read as a
 *  second fact. */
export const PUBLISH_STATE_LABEL: Record<PackageState, string> = {
  PUBLISHED: "Published",
  UNPUBLISHED: "Not published",
};

/** Distinct from `UNPUBLISHED`: no transition has happened at all, rather than
 *  a transition back to unpublished. */
export const NEVER_PUBLISHED_LABEL = "Not yet published";
